const transformTideDataToDays = data =>
  data.reduce(
    (days, currentTime) => {
      const compar = data[0].timestamp + 86400 * days.length;
      const previousDays = days.slice(0, days.length - 1);
      const currentDay = [...days[days.length - 1], currentTime];
      if (currentTime.timestamp < compar) {
        return [...previousDays, currentDay];
      }
      const nextDay = [currentTime];
      return [...previousDays, currentDay, nextDay];
    },
    [[]]
  );

export default transformTideDataToDays;
